/* eslint-disable no-unused-vars */
const prod = {
  hostName: 'https://ndd.logicarts.in',
  hostNameTms: 'https://dev.logicarts.in',
  sandeepApiKey: 'AIzaSyAXld-X2r3YqR6ah2-Hgk_r90nZo07ykXM'
};

const localhost = {
  hostName: 'https://localhost',
  hostNameTms: 'https://dev.logicarts.in',
  sandeepApiKey: 'AIzaSyAXld-X2r3YqR6ah2-Hgk_r90nZo07ykXM'
};

const heroku = {
  hostName: 'https://logicarts-ptl-server.herokuapp.com',
  hostNameTms: 'https://tms-ftsd-server.herokuapp.com',
  sandeepApiKey: 'AIzaSyAXld-X2r3YqR6ah2-Hgk_r90nZo07ykXM'
};

const config = prod;

export default {
  ...config
};
